import { nanoid } from 'nanoid'

export const useId = (value?: string) => {
  return value ?? nanoid(5)
}
